/* eslint-disable no-unused-vars */

export class States {
    static AUS = {
        ACT: "Australian Capital Territory",
        JBT: "Jervis Bay Territory",
        NSW: "New South Wales",
        NT: "Northern Territory",
        QLD: "Queensland",
        SA: "South Australia",
        TAS: "Tasmania",
        VIC: "Victoria",
        WA: "Western Australia"
    }

    static CAN = {
        AB: "Alberta",
        BC: "British Columbia",
        MB: "Mantitoba",
        NB: "New Brunswick",
        NL: "Newfoundland and Labrador",
        NS: "Nova Scotia",
        NT: "Northwest Territories",
        NU: "Nuvavut",
        ON: "Ontario",
        PE: "Prince Edward Island",
        QC: "Quebec",
        SK: "Saskatchewan",
        YT: "Yukon Territory"
    }

    static USA = {
        AK: "Alaska",
        AL: "Alabama",
        AR: "Arkansas",
        AS: "American Samoa",
        AZ: "Arizona",
        CA: "California",
        CO: "Colorado",
        CT: "Connecticut",
        DC: "District of Columbia",
        DE: "Delaware",
        FL: "Florida",
        GA: "Georgia",
        GU: "Guam",
        HI: "Hawaii",
        IA: "Iowa",
        ID: "Idaho",
        IL: "Illinois",
        IN: "Indiana",
        KS: "Kansas",
        KY: "Kentucky",
        LA: "Louisiana",
        MA: "Massachusetts",
        MD: "Maryland",
        ME: "Maine",
        MI: "Michigan",
        MN: "Minnesota",
        MO: "Missouri",
        MP: "Northern Mariana Islands",
        MS: "Mississippi",
        MT: "Montana",
        NC: "North Carolina",
        ND: "North Dakota",
        NE: "Nebraska",
        NH: "New Hampshire",
        NJ: "New Jersey",
        NM: "New Mexico",
        NV: "Nevada",
        NY: "New York",
        OH: "Ohio",
        OK: "Oklahoma",
        OR: "Oregon",
        PA: "Pennsylvania",
        PR: "Puerto Rico",
        RI: "Rhode Island",
        SC: "South Carolina",
        SD: "South Dakota",
        TN: "Tennessee",
        TT: "Trust Territories",
        TX: "Texas",
        UT: "Utah",
        VA: "Virginia",
        VI: "Virgin Islands",
        VT: "Vermont",
        WA: "Washington",
        WI: "Wisconsin",
        WV: "West Virginia",
        WY: "Wyoming"
    }
}

export enum Countries {
    ABW = "Aruba",
    AFG = "Afghanistan",
    AGO = "Angola",
    AIA = "Anguilla",
    ALA = "Åland Islands",
    ALB = "Albania",
    AND = "Andorra",
    ANT = "Netherlands Antilles",
    ARE = "United Arab Emirates",
    ARG = "Argentina",
    ARM = "Armenia",
    ASM = "American Samoa",
    ATA = "Antarctica",
    ATF = "French Southern and Antarctic Lands",
    ATG = "Antigua and Barbuda",
    AUS = "Australia",
    AUT = "Austria",
    AZE = "Azerbaijan",
    BDI = "Burundi",
    BEL = "Belgium",
    BEN = "Benin",
    BES = "Bonaire",
    BFA = "Burkina Faso",
    BGD = "Bangladesh",
    BGR = "Bulgaria",
    BHR = "Bahrain",
    BHS = "Bahamas, The",
    BIH = "Bosnia and Herzegovina",
    BLM = "Saint Barthélemy",
    BLR = "Belarus",
    BLZ = "Belize",
    BMU = "Bermuda",
    BOL = "Bolivia",
    BRA = "Brazil",
    BRB = "Barbados",
    BRN = "Brunei",
    BTN = "Bhutan",
    BVT = "Bouvet Island",
    BWA = "Botswana",
    CAF = "Central African Republic",
    CAN = "Canada",
    CCK = "Cocos (Keeling) Islands",
    CHE = "Switzerland",
    CHL = "Chile",
    CHN = "China",
    CIV = "Côte d’Ivoire",
    CMR = "Cameroon",
    COD = "Congo (DRC)",
    COG = "Congo",
    COK = "Cook Islands",
    COL = "Colombia",
    COM = "Comoros",
    CPV = "Cape Verde",
    CRI = "Costa Rica",
    CUB = "Cuba",
    CUW = "Curacao",
    CXR = "Christmas Island",
    CYM = "Cayman Islands",
    CYP = "Cyprus",
    CZE = "Czech Republic",
    DEU = "Germany",
    DJI = "Djibouti",
    DMA = "Dominica",
    DNK = "Denmark",
    DOM = "Dominican Republic",
    DZA = "Algeria",
    ECU = "Ecuador",
    EGY = "Egypt",
    ERI = "Eritrea",
    ESP = "Spain",
    EST = "Estonia",
    ETH = "Ethiopia",
    FIN = "Finland",
    FJI = "Fiji",
    FLK = "Falkland Islands (Islas Malvinas)",
    FRA = "France",
    FRO = "Faroe Islands",
    FSM = "Micronesia",
    GAB = "Gabon",
    GBR = "United Kingdom",
    GEO = "Georgia",
    GGY = "Guernsey",
    GHA = "Ghana",
    GIB = "Gibraltar",
    GIN = "Guinea",
    GLP = "Guadeloupe",
    GMB = "Gambia",
    GNB = "Guinea-Bissau",
    GNQ = "Equatorial Guinea",
    GRC = "Greece",
    GRD = "Grenada",
    GRL = "Greenland",
    GTM = "Guatemala",
    GUF = "French Guiana",
    GUM = "Guam",
    GUY = "Guyana",
    HKG = "Hong Kong S.A.R.",
    HMD = "Heard Island and McDonald Islands",
    HND = "Honduras",
    HRV = "Croatia",
    HTI = "Haiti",
    HUN = "Hungary",
    IDN = "Indonesia",
    IMN = "Isle of Man",
    IND = "India",
    IOT = "British Indian Ocean Territory",
    IRL = "Ireland",
    IRN = "Iran",
    IRQ = "Iraq",
    ISL = "Iceland",
    ISR = "Israel",
    ITA = "Italy",
    JAM = "Jamaica",
    JEY = "Jersey",
    JOR = "Jordan",
    JPN = "Japan",
    KAZ = "Kazakhstan",
    KEN = "Kenya",
    KGZ = "Kyrgyzstan",
    KHM = "Cambodia",
    KIR = "Kiribati",
    KNA = "Saint Kitts and Nevis",
    KOR = "Korea",
    KWT = "Kuwait",
    LAO = "Laos",
    LBN = "Lebanon",
    LBR = "Liberia",
    LBY = "Libya",
    LCA = "Saint Lucia",
    LIE = "Liechtenstein",
    LKA = "Sri Lanka",
    LSO = "Lesotho",
    LTU = "Lithuania",
    LUX = "Luxembourg",
    LVA = "Latvia",
    MAC = "Macao SAR",
    MAF = "Saint Martin",
    MAR = "Morocco",
    MCO = "Monaco",
    MDA = "Moldova",
    MDG = "Madagascar",
    MDV = "Maldives",
    MEX = "Mexico",
    MHL = "Marshall Islands",
    MKD = "Macedonia, Former Yugoslav Republic of",
    MLI = "Mali",
    MLT = "Malta",
    MMR = "Myanmar",
    MNE = "Montenegro",
    MNG = "Mongolia",
    MNP = "Northern Mariana Islands",
    MOZ = "Mozambique",
    MRT = "Mauritania",
    MSR = "Montserrat",
    MTQ = "Martinique",
    MUS = "Mauritius",
    MWI = "Malawi",
    MYS = "Malaysia",
    MYT = "Mayotte",
    NAM = "Namibia",
    NCL = "New Caledonia",
    NER = "Niger",
    NFK = "Norfolk Island",
    NGA = "Nigeria",
    NIC = "Nicaragua",
    NIU = "Niue",
    NLD = "Netherlands",
    NOR = "Norway",
    NPL = "Nepal",
    NRU = "Nauru",
    NZL = "New Zealand",
    OMN = "Oman",
    PAK = "Pakistan",
    PAN = "Panama",
    PCN = "Pitcairn Islands",
    PER = "Peru",
    PHL = "Philippines",
    PLW = "Palau",
    PNG = "Papua New Guinea",
    POL = "Poland",
    PRI = "Puerto Rico",
    PRK = "North Korea",
    PRT = "Portugal",
    PRY = "Paraguay",
    PSE = "Palestinian Authority",
    PYF = "French Polynesia",
    QAT = "Qatar",
    REU = "Reunion",
    ROU = "Romania",
    RUS = "Russia",
    RWA = "Rwanda",
    SAU = "Saudi Arabia",
    SDN = "Sudan",
    SEN = "Senegal",
    SGP = "Singapore",
    SGS = "South Georgia and the South Sandwich Islands",
    SHN = "Saint Helena, Ascension and Tristan da Cunha",
    SJM = "Svalbard and Jan Mayen Island",
    SLB = "Solomon Islands",
    SLE = "Sierra Leone",
    SLV = "El Salvador",
    SMR = "San Marino",
    SOM = "Somalia",
    SPM = "Saint Pierre and Miquelon",
    SRB = "Serbia",
    SSD = "South Sudan",
    STP = "São Tomé and Príncipe",
    SUR = "Suriname",
    SVK = "Slovakia",
    SVN = "Slovenia",
    SWE = "Sweden",
    SWZ = "Swaziland",
    SXM = "Sint Maarten",
    SYC = "Seychelles",
    SYR = "Syria",
    TCA = "Turks and Caicos Islands",
    TCD = "Chad",
    TGO = "Togo",
    THA = "Thailand",
    TJK = "Tajikistan",
    TKL = "Tokelau",
    TKM = "Turkmenistan",
    TLS = "Timor-Leste",
    TON = "Tonga",
    TTO = "Trinidad and Tobago",
    TUN = "Tunisia",
    TUR = "Turkey",
    TUV = "Tuvalu",
    TWN = "Taiwan R.O.C.",
    TZA = "Tanzania",
    UGA = "Uganda",
    UKR = "Ukraine",
    UMI = "U.S. Minor Outlying Islands",
    URY = "Uruguay",
    USA = "United States",
    UZB = "Uzbekistan",
    VAT = "Vatican City",
    VCT = "Saint Vincent and the Grenadines",
    VEN = "Venezuela",
    VGB = "British Virgin Islands",
    VIR = "Virgin Islands",
    VNM = "Vietnam",
    VUT = "Vanuatu",
    WLF = "Wallis and Futuna",
    WSM = "Samoa",
    XJA = "Jan Mayen",
    XKS = "Kosovo (use XKX)",
    XKX = "Kosovo",
    XSE = "Sint Eustatius",
    YEM = "Yemen",
    ZAF = "South Africa",
    ZMB = "Zambia",
    ZWE = "Zimbabwe"
}
